module.exports = __webpack_public_path__ + "img/plus.ecfa4fbf.svg";